import { isMobileApp, triggerMobileAppEvent } from "./mobile-app-integration";
import { ngAction } from "@sazka/ng/ng-integration";

function callDepositEvent() {
    if (isMobileApp) {
        triggerMobileAppEvent("openNgDeposit");
    } else {
        ngAction("showDeposit");
    }
}

function callMyAccountEvent() {
    if (isMobileApp) {
        triggerMobileAppEvent("openNgMyAccount");
    } else {
        ngAction("showMyAccount");
    }
}

function callOpenNgWithdrawal() {
    if (isMobileApp) {
        triggerMobileAppEvent("openNgWithdrawal");
    } else {
        ngAction("showWithdraw");
    }
}

function callGoToDeepLink(link: string, linkApp: string) {
    if (isMobileApp) {
        triggerMobileAppEvent("goToDeepLink", linkApp);
    } else {
        window.location.href = link;
    }
}

function mobileAppEventService(link: string, appEventName: string, appEventArgument: string, target = "_self") {
    if (isMobileApp) {
        triggerMobileAppEvent(appEventName, appEventArgument);
    } else if (link) {
        window.open(link, target);
    }
}

export function initMobileAppFunctions() {
    (window as any).callDepositEvent = callDepositEvent;
    (window as any).callMyAccountEvent = callMyAccountEvent;
    (window as any).callOpenNgWithdrawal = callOpenNgWithdrawal;
    (window as any).callGoToDeepLink = callGoToDeepLink;
    (window as any).mobileAppEventService = mobileAppEventService;
}
